(() => {
  const ywZh = (document.documentElement.lang || '').toLowerCase().startsWith('zh');
  const ywT = (cn, en) => ywZh ? cn : en;
  const rooms = {living:'客厅', bedroom:'卧室', dining:'餐厅', study:'书房', mattresses:'床垫'};
  const roomLabels = ywZh ? rooms : {living:'Living Room', bedroom:'Bedroom', dining:'Dining Room', study:'Study', mattresses:'Mattresses'};
  const uiKeys = ['yw_room','yw_stock','yw_black','yw_series','yw_query','yw_type'];
  function availableURL(value) {
    const url = new URL(value);
    const query = url.searchParams.get('q');
    if (query && !url.searchParams.has('yw_query') && !/\b[a-z_][a-z_.]*:/i.test(query) && globalThis.YeswoodSearchQuery) {
      url.searchParams.set('yw_query', query);
      url.searchParams.set('q', globalThis.YeswoodSearchQuery(query));
    }
    url.searchParams.set('filter.v.availability','1');
    url.searchParams.delete('filter.p.product_type');
    return url;
  }
  function stateFromURL(url) {
    const p = url.searchParams;
    const room = p.get('yw_room') || (/\/collections\/mattresses\/?$/.test(url.pathname) ? 'mattresses' : url.pathname.match(/(?:homepage-)?room-([^/]+)/)?.[1]) || 'all';
    return {room: rooms[room] ? room : 'all', stock:p.get('yw_stock') || '', series:(p.has('yw_series') ? p.get('yw_series').split(',') : p.get('yw_black') === '1' ? ['black'] : []).filter(v=>['black','walnut','oak','ash','light','fabric','leather'].includes(v)), query:p.has('yw_query') ? p.get('yw_query') : (p.get('q') || ''), productType:p.get('yw_type') || (/\/collections\/mattresses\/?$/.test(url.pathname) ? 'Mattress' : '')};
  }
  function buildURL(state, current, root) {
    const url = availableURL(current);
    const clauses = [];
    if (state.query.trim()) clauses.push(`(${globalThis.YeswoodSearchQuery ? globalThis.YeswoodSearchQuery(state.query) : state.query.trim()})`);
    if (rooms[state.room] && state.room !== 'mattresses') clauses.push(`tag:${rooms[state.room]}`);
    if (state.stock === 'yes') clauses.push('tag:预售');
    if (state.stock === 'no') clauses.push('-tag:预售');
    const series = state.series || (state.black ? ['black'] : []);
    const seriesQueries = {black:'(tag:黑标 OR title:黑标)',walnut:'tag:黑胡桃木',oak:'(tag:橡木 OR tag:白橡木 OR tag:红橡木)',ash:'tag:白蜡木',fabric:'tag:布艺',leather:'tag:真皮',light:'(-tag:黑胡桃木)'};
    const selectedSeries = series.filter(v=>seriesQueries[v]);
    if (selectedSeries.length) clauses.push('(' + selectedSeries.map(v=>seriesQueries[v]).join(' OR ') + ')');
    if (state.productType) clauses.push(`product_type:"${state.productType.replace(/[\\"]/g, '\\$&')}"`);
    const search = state.query.trim() || state.stock || selectedSeries.length || (state.productType && state.room !== 'mattresses');
    if (state.productType === 'Mattress') clauses.push('tag:床垫');
    url.hash = '';
    url.pathname = search ? `${root}search` : `${root}collections/${state.room === 'mattresses' ? 'mattresses' : rooms[state.room] ? 'room-' + state.room : 'all'}`;
    ['q','type','options[prefix]','page','section_id',...uiKeys].forEach(key => url.searchParams.delete(key));
    if (search) {
      url.searchParams.set('q', clauses.join(' AND '));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
    }
    url.searchParams.set('yw_room', state.room);
    url.searchParams.set('yw_stock', state.stock);
    url.searchParams.set('yw_series',selectedSeries.join(','));
    url.searchParams.set('yw_query', state.query);
    if (state.productType) url.searchParams.set('yw_type', state.productType);
    // Collection and search use different default ordering names.
    const sort = url.searchParams.get('sort_by');
    if (search && ['manual','best-selling','created-descending'].includes(sort)) url.searchParams.set('sort_by','relevance');
    if (!search && ['relevance','most-relevant'].includes(sort)) url.searchParams.set('sort_by','manual');
    return url;
  }
  function restoreDrawer(drawer, openIds, focusedElement, focusTrap) {
    if (!drawer?.mainDetailsToggle) return;
    drawer.mainDetailsToggle.open = true;
    drawer.openMenuDrawer(drawer.mainDetailsToggle.querySelector('summary'));
    let activePanel;
    drawer.querySelectorAll('details').forEach(details => {
      if (!openIds.includes(details.id)) return;
      details.open = true;
      details.classList.add('menu-opening');
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-expanded', 'true');
      details.closest('.has-submenu')?.classList.add('submenu-open');
      activePanel = summary.nextElementSibling;
    });
    if (activePanel) {
      focusTrap(activePanel, activePanel.contains(focusedElement) ? focusedElement : activePanel.querySelector('button'));
    } else if (drawer.mainDetailsToggle.contains?.(focusedElement)) {
      focusedElement.focus({preventScroll:true});
    }
  }
  if (typeof module !== 'undefined') module.exports = {stateFromURL,buildURL,availableURL,restoreDrawer};
  if (typeof document === 'undefined') return;
  const toolbar = document.getElementById('YWCatalogToolbar');
  const results = document.getElementById('YWCatalogResults');
  if (!toolbar || !results) return;
  const input = toolbar.querySelector('input[name=q]');
  const status = document.getElementById('YWCatalogStatus');
  const retry = document.getElementById('YWCatalogRetry');
  const root = toolbar.dataset.root;
  let pendingURL = new URL(location.href), controller;
  const initialType = toolbar.dataset.productType;
  history.scrollRestoration = 'manual';
  let navigating = false, scrollTimer;
  function savePosition() {
    if (!navigating) history.replaceState({...history.state,ywScroll:window.scrollY},'',location.href);
  }
  history.replaceState({...history.state,ywScroll:window.scrollY},'',location.href);
  window.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(savePosition,100); }, {passive:true});
  function syncUI(url) {
    const state = stateFromURL(url);
    input.value = state.query;
    const sort = url.searchParams.get('sort_by') || 'general';
    const mode = results.querySelector('[data-yw-sort-mode]');
    if (mode) { mode.value = sort === 'created-descending' ? sort : 'general';mode.classList.toggle('is-active',['general','manual','relevance','most-relevant','created-descending'].includes(sort)); }
    results.querySelector('[data-yw-sort="best-selling"]')?.classList.toggle('is-active',sort === 'best-selling');
    const priceSort = results.querySelector('[data-yw-price-sort]');
    if (priceSort) { priceSort.textContent = sort === 'price-ascending' ? ywT('价格 ↑', 'Price ↑') : sort === 'price-descending' ? ywT('价格 ↓', 'Price ↓') : ywT('价格 ↕', 'Price ↕');priceSort.classList.toggle('is-active',sort.startsWith('price-'));priceSort.setAttribute('aria-label',sort === 'price-ascending' ? ywT('价格排序，点击从高到低', 'Sort by price, high to low') : ywT('价格排序，点击从低到高', 'Sort by price, low to high')); }
    for (const [id,key] of [['YWPriceMin','filter.v.price.gte'],['YWPriceMax','filter.v.price.lte']]) {const el=results.querySelector('#'+id);if(el) el.value=url.searchParams.get(key)||'';}
    const heading = document.getElementById('YWCatalogHeading');
    const label = state.query.trim() ? ywT(`${state.query.trim()}的搜索结果`, `Search results for “${state.query.trim()}”`) : state.room === 'mattresses' ? ywT('床垫', 'Mattresses') : rooms[state.room] ? ywT(`${roomLabels[state.room]}家具`, `${roomLabels[state.room]} Furniture`) : url.pathname.endsWith('/search') ? ywT('家具筛选结果', 'Filtered furniture') : toolbar.dataset.collection === 'all' || /room-/.test(toolbar.dataset.collection) ? ywT('全部家具', 'All Furniture') : heading.textContent;
    heading.textContent = label;
    document.title = `${label} – YesWood Home`;
    const enquiry = results.querySelector('[data-yw-enquiry]');
    if (enquiry) {
      const mail = new URL(enquiry.href);
      mail.searchParams.set('subject',ywT(`商品咨询：${state.query || label}`, `Product inquiry: ${state.query || label}`));
      mail.searchParams.set('body',ywT(`我想咨询：${state.query || label}\n浏览页面：${url.href}\n商品链接或图片：`, `I'd like to ask about: ${state.query || label}\nPage: ${url.href}\nProduct link or picture: `));
      enquiry.href = mail.href;
    }
    toolbar.querySelector('predictive-search,search-form')?.toggleResetButton?.();
    results.querySelectorAll('[data-yw-stock]').forEach(el => {if(el.tagName === 'SELECT'){el.value=state.stock;}else{el.checked = el.value === state.stock;}});
    results.querySelectorAll('[data-yw-series]').forEach(el => {el.checked = state.series.includes(el.value);});
    toolbar.querySelectorAll('[data-room]').forEach(link => {
      if (link.dataset.room === state.room) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });
  }
  async function render(url, push = true, action = 'filter', restoreY) {
    url = availableURL(new URL(url, location.href));
    if (url.origin !== location.origin) return;
    if (push) savePosition();
    navigating = true;
    controller?.abort();
    const request = new AbortController();
    controller = request;
    pendingURL = url;
    syncUI(url);
    retry.hidden = true;
    status.textContent = ywT('正在更新商品…', 'Updating products…');
    results.setAttribute('aria-busy','true');
    try {
      const response = await fetch(url, {signal:request.signal});
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = doc.getElementById('YWCatalogResults');
      if (!replacement || !replacement.querySelector('#ProductGridContainer')) throw new Error('Missing catalog');
      if (request.signal.aborted) return;
      const y = window.scrollY;
      const focusId = results.contains(document.activeElement) ? document.activeElement.id : '';
      const drawerWasOpen = !!results.querySelector('menu-drawer > details[open]');
      const openFilterIds = [...results.querySelectorAll('menu-drawer > details details[open]:not([data-yw-filter-group])')].map(el => el.id);
      const filterStates = [...results.querySelectorAll('details[id]')].map(el=>({id:el.id,open:el.open,scroll:el.querySelector('.facets__list')?.scrollTop}));
      if (drawerWasOpen) removeTrapFocus();
      results.innerHTML = replacement.innerHTML;
      syncUI(url);
      filterStates.forEach(({id,open,scroll})=>{
        const el=document.getElementById(id);
        if(el){el.open=open;const list=el.querySelector('.facets__list');if(list && scroll!==undefined)list.scrollTop=scroll;}
      });
      if (drawerWasOpen) {
        restoreDrawer(results.querySelector('menu-drawer'), openFilterIds, document.getElementById(focusId), trapFocus);
      }
      results.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
      if (focusId && !drawerWasOpen) document.getElementById(focusId)?.focus({preventScroll:true});

      document.getElementById('MainContent').dataset.template = doc.getElementById('MainContent').dataset.template;
      if (push) history.pushState({ywCatalog:true,searchParams:url.search.slice(1),ywScroll:0}, '', url);
      const target = document.getElementById('YWCatalogHeading');
      if (action === 'page') {
        target.focus({preventScroll:true});
        const header = document.querySelector('.section-header')?.getBoundingClientRect().height || 80;
        window.scrollTo({top:target.getBoundingClientRect().top + window.scrollY - header - 16,behavior:'instant'});
      } else {
        window.scrollTo({top:restoreY ?? y,behavior:'instant'});
      }
      history.replaceState({...history.state,ywScroll:window.scrollY},'',location.href);
      status.textContent = action === 'page' ? ywT(`已切换到第 ${url.searchParams.get('page') || 1} 页`, `Page ${url.searchParams.get('page') || 1}`) : '';
      retry.hidden = true;
    } catch (error) {
      if (error.name === 'AbortError') return;
      syncUI(new URL(location.href));
      status.textContent = ywT('更新失败，已保留当前商品。请重试。', 'Update failed; current products kept. Please try again.');
      retry.hidden = false;
    } finally {
      if (controller === request) { results.removeAttribute('aria-busy'); navigating = false; }
    }
  }
  function submit(room, change = {}) {
    const state = {...stateFromURL(pendingURL), query:input.value, ...change};
    if (room) {state.room = room;state.productType = room === 'mattresses' ? 'Mattress' : '';}
    else if (!state.productType && initialType && !pendingURL.searchParams.has('yw_room')) state.productType = initialType;
    const url = buildURL(state,pendingURL,root);
    toolbar.querySelector('predictive-search')?.close();
    render(url);
  }
  window.YeswoodCatalog = {
    filter(params, push) {
      const url = new URL(location.href);
      url.search = params;
      [...uiKeys,'sort_by','filter.v.price.gte','filter.v.price.lte'].forEach(key => {if (pendingURL.searchParams.has(key) && !url.searchParams.has(key)) url.searchParams.set(key,pendingURL.searchParams.get(key));});
      if (url.pathname.endsWith('/search')) url.searchParams.set('type','product');
      return render(url,push);
    }
  };
  toolbar.addEventListener('submit', event => {
    if (event.target !== input.form) return;
    // Keep predictive result selection native; otherwise search within the current filters.
    if (toolbar.querySelector('[aria-selected=true] a')) return;
    event.preventDefault();submit();
  });
  function sortResults(value) {
    const url = new URL(pendingURL);url.searchParams.delete('page');
    url.searchParams.set('sort_by',value === 'general' ? url.pathname.endsWith('/search') ? 'relevance' : 'manual' : value);
    render(url);
  }
  results.addEventListener('submit',event=>{
    if (!event.target.matches('[data-yw-price-range]')) return;
    event.preventDefault();
    const min=event.target.querySelector('#YWPriceMin'),max=event.target.querySelector('#YWPriceMax');
    max.setCustomValidity(min.value && max.value && Number(min.value)>Number(max.value) ? ywT('最高价不能小于最低价', 'Max price cannot be lower than min price') : '');
    if (!event.target.reportValidity()) return;
    const url=new URL(pendingURL);url.searchParams.delete('page');
    for(const el of [min,max]) {if(el.value)url.searchParams.set(el.name,el.value);else url.searchParams.delete(el.name);}
    render(url);
  });
  results.addEventListener('input',event=>{if(event.target.closest('[data-yw-price-range]'))results.querySelector('#YWPriceMax').setCustomValidity('');});
  results.addEventListener('change', event => {
    if (event.target.matches('[data-yw-sort-mode]')) {sortResults(event.target.value);return;}

    if (event.target.matches('[data-yw-stock]')) submit(null,{stock:event.target.value});
    if (event.target.matches('[data-yw-series]')) {
      const selected = new Set(stateFromURL(pendingURL).series);
      event.target.checked ? selected.add(event.target.value) : selected.delete(event.target.value);
      submit(null,{series:[...selected]});
    }
  });
  retry.addEventListener('click', () => render(pendingURL));
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const sortButton = event.target.closest('[data-yw-sort],[data-yw-price-sort]');
    if (sortButton && !sortButton.disabled) {
      event.preventDefault();
      const sort = sortButton.hasAttribute('data-yw-price-sort') ? pendingURL.searchParams.get('sort_by') === 'price-ascending' ? 'price-descending' : 'price-ascending' : sortButton.dataset.ywSort;
      sortResults(sort);return;
    }
    const changeQuery = event.target.closest('[data-yw-change-query]');
    if (changeQuery) { input.focus(); input.select(); input.scrollIntoView({block:'center'}); return; }
    const clear = event.target.closest('[data-yw-clear]');
    if (clear) {
      event.preventDefault();
      const state = stateFromURL(pendingURL);
      const clean = new URL(pendingURL);
      [...clean.searchParams.keys()].filter(k=>k.startsWith('filter.')).forEach(k=>clean.searchParams.delete(k));
      render(buildURL({...state,stock:'',series:[],productType:''},clean,root),true,'page');
      return;
    }
    const room = event.target.closest('#YWCatalogToolbar [data-room]');
    if (room) {event.preventDefault();submit(room.dataset.room);return;}
    const link = event.target.closest('#YWCatalogResults .pagination a');
    if (link) {
      event.preventDefault();
      const url = new URL(link.href);
      uiKeys.forEach(key => {if (pendingURL.searchParams.has(key)) url.searchParams.set(key,pendingURL.searchParams.get(key));});
      render(url,true,'page');
    }
  });
  window.addEventListener('popstate', event => { clearTimeout(scrollTimer); render(new URL(location.href),false,'back',event.state?.ywScroll ?? 0); });
  // Normalize plain search URLs from bookmarks and external links, too.
  const normalizedSearch = availableURL(pendingURL);
  if (normalizedSearch.searchParams.get('q') !== pendingURL.searchParams.get('q')) {
    pendingURL = normalizedSearch;
    history.replaceState({...history.state}, '', pendingURL);
    render(pendingURL, false);
  }
  // Default fresh catalog entries; explicit selections (including empty) remain unchanged.
  const explicit = [...pendingURL.searchParams.keys()].some(k=>k.startsWith('yw_') || k === 'q' || (k.startsWith('filter.') && k !== 'filter.v.availability' && pendingURL.searchParams.get(k)));
  if (!explicit && /\/collections\/(all|(?:homepage-)?room-(living|bedroom|dining|study))\/?$/.test(pendingURL.pathname)) {
    pendingURL = buildURL({...stateFromURL(pendingURL),series:['black','walnut']},pendingURL,root);
    history.replaceState({...history.state},'',pendingURL);
    render(pendingURL,false);
  }
  if (!pendingURL.searchParams.has('sort_by')) {
    pendingURL.searchParams.set('sort_by',pendingURL.pathname.endsWith('/search')?'relevance':'manual');
    history.replaceState({...history.state},'',pendingURL);
    render(pendingURL,false);
  }
  syncUI(pendingURL);
  const legacyRoom = /\/collections\/homepage-room-(living|bedroom|dining|study)\/?$/.test(pendingURL.pathname);
  if (legacyRoom) pendingURL.pathname = pendingURL.pathname.replace('/collections/homepage-room-','/collections/room-');
  if (legacyRoom || pendingURL.searchParams.has('filter.p.product_type') || pendingURL.searchParams.getAll('filter.v.availability').join(',') !== '1') {
    pendingURL = availableURL(pendingURL);
    history.replaceState({...history.state,searchParams:pendingURL.search.slice(1)},'',pendingURL);
    render(pendingURL,false);
  }
})();
